// Low GPA/CGPA warning & scholarship restriction — shared frontend helpers.
// Keep the message strings byte-for-byte in sync with backend
// gpaWarningController.js (WARN_MESSAGE / BLOCK_MESSAGE).

export const LOW_GPA_THRESHOLD = 3;

export const LOW_GPA_WARNING_TEXT =
  "This time, your scholarship is being awarded despite your GPA/CGPA being below 3.00. " +
  "If your GPA/CGPA remains below 3.00 in the next semester, your scholarship will be discontinued.";

export const LOW_GPA_BLOCK_TEXT =
  "A warning has already been issued to you in the previous semester due to your low GPA/CGPA. " +
  "As your GPA/CGPA is again below 3.00, you are not eligible to proceed with this scholarship application.";

// A value at/above 3.00 is fine. Blank / non-positive / percentage-looking
// values do not trip the rule.
export function isLowGpa(value) {
  const n = Number(value);
  return Number.isFinite(n) && n > 0 && n < LOW_GPA_THRESHOLD;
}
